/**
 * Holds the auth engine singleton slot. The engine itself is constructed in
 * src/lib/authStore.ts — this file only owns the slot and the test reset.

 *
 * This module deliberately imports NOTHING — the test setup file imports it to
 * reset the engine between tests, and pulling in the Supabase client there
 * would load `authStore` (and a real client) before any test file's `vi.mock`
 * could take effect.
 */

export interface AuthEngineSlot {
  engine: unknown;
  teardown: (() => void) | null;
}

const slot: AuthEngineSlot = { engine: null, teardown: null };

export function getEngineSlot(): AuthEngineSlot {
  return slot;
}

/**
 * Test-only. The engine is a module singleton that intentionally outlives every
 * component, so without this a resolved session would leak into later tests.
 * Called from src/test/setup.ts in a global beforeEach.
 */
export function __resetAuthEngineForTests() {
  try {
    slot.teardown?.();
  } catch {
    // ignore
  }
  slot.engine = null;
  slot.teardown = null;
}
